<template>
  <b-modal
    ref="modalSlot"
    id="ModalSlot"
    class="modal-slot"
    :class="{
      w400px: width == 'w400px',
      w500px: width == 'w500px',
      w600px: width == 'w600px'
    }"
    header-class="modal-confirm-header"
    body-class="modal-confirm-body"
    footer-class="modal-confirm-footer"
    auto-focus-button
    @hide="cancelButton"
  >
    <div slot="modal-header" style="position: relative;" class="title-area modal-confirm">
      <!-- <font-awesome-icon class="fa-3x" icon="exclamation-circle" /> -->
      <h5 class="modal-title" id="ModalAdicionarTitulo">{{ labels.title }}</h5>

      <button
        :disabled="finallyLoad"
        style="position: absolute; top: -5px; right: 0; color: #666;"
        class="b-close-slot"
        @click="cancelButton"
      >
        <font-awesome-icon class="fa-x" icon="times" />
      </button>
    </div>

    <div class="labels-message" v-html="labels.message"></div>

    <slot name="body"></slot>
    <slot name="msg-confirm"></slot>

    <div slot="modal-footer">
      <div class="footer-modal">
        <BotaoPadrao
          v-if="typeof cancelButton === 'function' && !hideCancel"
          arredondadoEsquerda
          class="botao-modal"
          nome="Cancelar"
          icone="times"
          :click="cancelButton"
        />
        <BotaoPadrao
          v-if="typeof deleteButton === 'function'"
          arredondadoEsquerda
          class="botao-modal"
          nome="Excluir"
          icone="check"
          :click="deleteButton"
          cor="vermelho"
        />
        <BotaoPadrao
          v-if="typeof confirmAction === 'function'"
          arredondadoEsquerda
          class="botao-modal"
          nome="Confirmar"
          icone="check"
          :click="handleConfirmAction"
          :disabled="loading || selected"
          cor="azul"
        />
        <button
          v-if="typeof returnButton === 'function'"
          type="button"
          class="btn btn-secondary mr-2 float-right"
          @click="returnButton"
          :disabled="finallyLoad"
        >
          Voltar
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
export default {
  name: "ModalSlot",
  components: {
    BotaoPadrao
  },
  props: {
    blShow: Boolean,
    labels: {
      title: String,
      message: String
    },
    confirmAction: Function,
    cancelButton: Function,
    returnButton: Function || undefined || null,
    deleteButton: Function || undefined || null,
    selected: Boolean,
    width: String || undefined || null,
    hideCancel: Boolean || undefined || null,
    finallyLoad: Boolean || undefined || null
  },
  data() {
    return {
      loading: false
    };
  },
  mounted() {
    this.toggle(this.blShow);
    this.loading = false;
  },
  methods: {
    show: function() {
      this.$refs.modalSlot.show();
    },
    hide: function() {
      this.$refs.modalSlot.hide();
    },
    toggle: function(value) {
      if (value) {
        this.show();
      } else {
        this.hide();
      }
    },
    handleConfirmAction: function() {
      this.$root.$emit("bv::hide::tooltip", "btn-confirmar-modalSlot");

      let that = this;
      this.loading = true;

      setTimeout(function() {
        that.loading = false;
      }, 2000);

      setTimeout(function() {
        that.confirmAction();
      }, 1000);
    }
  },
  watch: {
    blShow: function(value) {
      this.toggle(value);
    }
  }
};
</script>

<style lang="scss">
.footer-modal {
  display: flex;
}

.modal-slot {
  .modal-dialog {
    max-width: 1000px;
  }

  .modal-body {
    padding: 0;
  }
}

.modal-slot.w400px {
  .modal-dialog {
    max-width: 400px !important;
  }
}
.modal-slot.w500px {
  .modal-dialog {
    max-width: 500px !important;
  }
}
.modal-slot.w600px {
  .modal-dialog {
    max-width: 600px !important;
  }
}

.labels-message {
  margin: 0 0 5px;
}

.modal-confirm-header {
  // display: flex;
  // justify-content: center ;
  color: #007bff;
  background-color: var(--branco);
  border-bottom: 0;
  text-align: center;
}

.modal-confirm-header .modal-confirm {
  width: 100%;
}

.modal-confirm-header .modal-confirm button.close {
  position: absolute;
  top: 16px;
  right: 16px;
}

.modal-confirm-body {
  text-align: center;
  margin-bottom: 15px;
}

.modal-confirm-footer .btn-secondary {
  background: #9e9e9e;
}

.modal-confirm-header .fa-times-circle {
  font-size: 70px;
  margin-bottom: 10px;
  margin-top: 10px;
}

button.btn-confirma-focus:focus {
  outline: 0 !important;
  background-color: #0068d8 !important;
}
.fa-x {
  color: var(--vermelho3) !important;
  cursor: pointer;
  height: 19px !important;
  width: 19px !important;
}
</style>
